export const USER_ROLE_VALUES = ['user', 'admin', 'superadmin'] as const

export type UserRole = (typeof USER_ROLE_VALUES)[number]

export function isAdminRole(role: string | undefined) {
    return role === 'admin' || role === 'superadmin'
}

export function isUserRole(role: string): role is UserRole {
    return USER_ROLE_VALUES.includes(role as UserRole)
}
